import { GAME_ID, REDUX_ACTIONS } from 'a/doubleTrouble/data/constants';

const initialState = { isDraggable: true };

const draggabilityReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }
  switch (action.type) {
    case REDUX_ACTIONS.SET_DRAGGABLE: {
      return { isDraggable: action.payload };
    }
    default:
      return state;
  }
};

export default draggabilityReducer;
